var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategicbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1526,
    height: 673,
    viewBox: "0 0 1526 673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1175 414"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1175,
    height: 414,
    xlinkHref: "data:image/jpeg;base64,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"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(-197 -5764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(-3122 169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-721 4108)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-2",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-2",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-2",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-2",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-2",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-2",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-3",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-3",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-3",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-3",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-3",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-2",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-4",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-4",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-4",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-4",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-4",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-2",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-3",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-5",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-5",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-5",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-5",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-5",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-3",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-6",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-6",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-6",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-6",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-6",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-2",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-4",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-7",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-7",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-7",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-7",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-7",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-4",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-8",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-8",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-8",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-8",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-8",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-2",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-3",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-5",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-9",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-9",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-9",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-9",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-9",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-5",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-10",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-10",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-10",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-10",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-10",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-3",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-6",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-11",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-11",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-11",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-11",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-11",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-6",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-12",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-12",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-12",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-12",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-12",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-2",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-4",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-7",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-13",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-13",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-13",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-13",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-13",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-7",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-14",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-14",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-14",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-14",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-14",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-4",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-8",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-15",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-15",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-15",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-15",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-15",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-8",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-16",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-16",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-16",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-16",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-16",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(-801 4108)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161-2",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-3",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-5",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-9",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-17",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-17",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-17",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-17",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-17",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-9",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-18",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-18",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-18",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-18",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-18",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-5",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-10",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-19",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-19",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-19",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-19",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-19",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-10",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-20",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-20",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-20",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-20",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-20",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-3",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-6",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-11",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-21",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-21",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-21",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-21",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-21",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-11",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-22",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-22",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-22",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-22",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-22",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-6",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-12",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-23",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-23",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-23",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-23",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-23",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-12",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-24",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-24",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-24",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-24",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-24",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162-2",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-4",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-7",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-13",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-25",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-25",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-25",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-25",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-25",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-13",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-26",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-26",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-26",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-26",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-26",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-7",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-14",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-27",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-27",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-27",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-27",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-27",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-14",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-28",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-28",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-28",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-28",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-28",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-4",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-8",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-15",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-29",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-29",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-29",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-29",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-29",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-15",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-30",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-30",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-30",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-30",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-30",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-8",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-16",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-31",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-31",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-31",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-31",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-31",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-16",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-32",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-32",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-32",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-32",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-32",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(-5398 11116) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202-2",
    "data-name": "Group 202",
    transform: "translate(-721 4108)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161-3",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-5",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-9",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-17",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-33",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-33",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-33",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-33",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-33",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-17",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-34",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-34",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-34",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-34",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-34",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-9",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-18",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-35",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-35",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-35",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-35",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-35",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-18",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-36",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-36",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-36",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-36",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-36",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-5",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-10",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-19",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-37",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-37",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-37",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-37",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-37",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-19",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-38",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-38",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-38",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-38",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-38",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-10",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-20",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-39",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-39",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-39",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-39",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-39",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-20",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-40",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-40",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-40",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-40",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-40",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162-3",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-6",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-11",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-21",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-41",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-41",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-41",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-41",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-41",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-21",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-42",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-42",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-42",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-42",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-42",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-11",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-22",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-43",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-43",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-43",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-43",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-43",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-22",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-44",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-44",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-44",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-44",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-44",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-6",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-12",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-23",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-45",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-45",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-45",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-45",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-45",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-23",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-46",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-46",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-46",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-46",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-46",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-12",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-24",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-47",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-47",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-47",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-47",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-47",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-24",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-48",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-48",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-48",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-48",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-48",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203-2",
    "data-name": "Group 203",
    transform: "translate(-801 4108)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161-4",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-7",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-13",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-25",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-49",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-49",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-49",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-49",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-49",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-25",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-50",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-50",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-50",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-50",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-50",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-13",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-26",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-51",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-51",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-51",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-51",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-51",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-26",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-52",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-52",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-52",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-52",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-52",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-7",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-14",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-27",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-53",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-53",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-53",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-53",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-53",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-27",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-54",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-54",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-54",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-54",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-54",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-14",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-28",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-55",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-55",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-55",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-55",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-55",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-28",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-56",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-56",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-56",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-56",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-56",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162-4",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-8",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-15",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-29",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-57",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-57",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-57",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-57",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-57",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-29",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-58",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-58",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-58",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-58",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-58",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-15",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-30",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-59",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-59",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-59",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-59",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-59",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-30",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-60",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-60",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-60",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-60",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-60",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-8",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-16",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-31",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-61",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-61",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-61",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-61",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-61",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-31",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-62",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-62",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-62",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-62",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-62",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-16",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-32",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-63",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-63",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-63",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-63",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-63",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-32",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-64",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-64",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-64",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-64",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-64",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(-3909 -897)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "h2-bg-section-05",
    width: 1467,
    height: 516,
    rx: 24,
    transform: "translate(4132 6778)",
    fill: "url(#pattern)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicbg);
export default __webpack_public_path__ + "static/media/strategicbg.497a163f8a6a1a9019c65c48e6962568.svg";
export { ForwardRef as ReactComponent };